import * as React from "react";

import { MiddlewareAction } from ".";

export const useRelodeReducer = <F extends React.Reducer<React.ReducerState<F>, React.ReducerAction<F>>>(
    reducer: F,
    initialState: React.ReducerState<F>,
    middleware: MiddlewareAction | MiddlewareAction[] = []
) => {
    const [state, dispatch] = React.useReducer(reducer, initialState);
    const middlewareList = Array.isArray(middleware) ? middleware : [middleware];
    if (!Array.isArray(middleware)) middleware = [middleware];
    const _dispatch: React.Dispatch<React.ReducerAction<F>> = (action: React.ReducerAction<F>) => {
        middlewareList.forEach(m => m(action));
        return dispatch(action);
    };
    return [state, _dispatch] as [React.ReducerState<F>, React.Dispatch<React.ReducerAction<F>>];
};
